import moment from 'moment';
import { loadBasins } from '../../api/forecasts/loadBasins.api';
import { loadLocations } from '../../api/forecasts/locationId.api';
import { loadForecasts, loadFlowForecasts,} from '../../api/forecasts/forecasts.api';
import { loadSummaryMonth } from '../../api/forecasts/summary-monthly.api';
import { loadClimatographicAverage } from '../../api/forecasts/climatologicalaverage.api'
import { loadWaterAvailability } from '../../api/forecasts/wateravailability.api'
import { loadReservoirLatestDailySummary, loadSaicDailySummaryAPI, loadSaicMonthlySummaryAPI } from '../../api/saic/summaries.api'
import { loadFlowDurationCurve } from '../../api/rest-forecasts/flow-duration-curve.api'
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  locations: [],
  forecasts: [],
  flowForecasts: [],
  basins: [],
  locacronymn: {},
  rainfallEstimateHistory: [],
  monitoringDailyForecast: [],
  monitoringDailyForecastFlows: [],
  affluentFlowForecast: [],
  climatographicAverage: [],
  waterAvailability: [],
  meteorologicalForecast: [],
  params: {},
  saicReservoirCardSummary: [],
  saicDailySummary: [],
  saicMonthlySummary: [],
  flowDurationCurve: {},
};

const mutations = {
  setLocations(state, data){
    state.locations = data ? data : [];
  },
  setForecasts(state, data){
    state.forecasts = data ? data : [];
  },
  cleanLocations(state){
    state.locations = [];
  },
  cleanForecasts(state){
    state.forecasts = [];
  },
  setBasins(state, data){
    state.basins = data ? data : [];
  },
  setLocacronymn(state, data){
    state.locacronymn = data ? data : {};
  },
  setRainfallEstimateHistory(state, data){
    state.rainfallEstimateHistory = data ? data : [];
  },
  setFlowForecasts(state, data){
    state.flowForecasts = data ? data : [];
  },
  setMonitoringDailyForecast(state, data){
    state.monitoringDailyForecast = data ? data : [];
  },
  setWaterAvailability(state, data){
    state.waterAvailability = data ? data : [];
  },
  setAffluentFlowForecast(state, data){
    state.affluentFlowForecast = data ? data : [];
  },
  setMonitoringDailyForecastFlows(state, data){
    state.monitoringDailyForecastFlows = data ? data : [];
  },
  setClimatographicAverage(state, data){
    state.climatographicAverage = data ? data : [];
  },
  setClimatographicAverageSaic(state, data){
    state.climatographicAverageSaic = data ? data : [];
  },
  setMeteorologicalForecast(state, data){
    state.meteorologicalForecast = data ? data : [];
  },
  setParams(state, data){
    state.params = data ? data : {};
  },
  setSaicReservoirCardSummary(state, data){
    state.saicReservoirCardSummary = data ? data : [];
  },
  setSaicDailySummary(state, data){
    state.saicDailySummary = data ? data : [];
  },
  setSaicMonthlySummary(state, data){
    state.saicMonthlySummary = data ? data : [];
  },
  setFlowDurationCurve(state, data){
    state.flowDurationCurve = data ? data : {};
  },
};

const actions = {
  async loadLocations( {commit}, payload ){
        const {customer_id} = payload;

        try{
          const response = await loadLocations({customer_id});
          commit('setLocations', response.data);
        }catch(error){
          Vue.$toast.open({
            message: `Não foram encontrados locais para esse cliente .`,
            type: "error",
            duration: 5000,
            dismissible: true
          });
          commit('setLocations', undefined);
        }
  },
  async loadLocationById( {commit}, payload ){
        const {customer_id, location_id} = payload;

        try{
          const response = await loadLocations({customer_id, location_id});
          commit('setLocations', response.data);
        }catch(error){
          commit('setLocations', undefined);
          Vue.$toast.open({
            message: `O local de id: ${location_id}, não foi encontrado para esse cliente.`,
            type: "error",
            duration: 5000,
            dismissible: true
          });
        }
  },
  async loadLocationsByBasin( {commit}, payload ){
        const {customer_id, basin_id} = payload;

        try{
          const response = await loadLocations({customer_id, basin_id});
          commit('setLocations', response.data);
        }catch(error){
          Vue.$toast.open({
            message: `Ocorreu um erro ao fazer a busca para a bacia de id: ${basin_id}.`,
            type: "error",
            duration: 5000,
            dismissible: true
          });
          commit('setLocations', undefined);
        }
  },

  async loadClimatographicAverage( {commit}, payload ){
    const {month, variable, location_id} = payload;
    let response;
    try{
      response = await loadClimatographicAverage(month, variable, location_id);
      commit('setClimatographicAverage', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das informações para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setClimatographicAverage', undefined);
    }
  },

  async loadClimatographicAverageSaic( {commit}, payload ){
    const {month, variable, location_id} = payload;
    let response;
    try{
      response = await loadClimatographicAverage(month, variable, location_id);
      commit('setClimatographicAverageSaic', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das informações para o mês: ${month} e a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setClimatographicAverageSaic', undefined);
    }
  },

  async loadForecasts( {commit}, payload ){
        const {type, initial_date, final_date, source, customer_id} = payload;
        let response;

        try{
          if(type === 'monthly'){
              response = await loadSummaryMonth(initial_date, final_date, source, customer_id);
          }else{
              response = await loadForecasts({type, initial_date, final_date, source, customer_id});
          }
          commit('setForecasts', response.data);
        }catch(error){
          Vue.$toast.open({
            message: `Ocorreu um erro ao fazer a busca das previsões.`,
            type: "error",
            duration: 5000,
            dismissible: true
          });
          commit('setForecasts', undefined);
        }

  },
  async loadForecastByLocationId( {commit}, payload ){
        const {type, initial_date, final_date, source, customer_id, location_id} = payload;

        try{
          const response = await loadForecasts({type, initial_date, final_date, source, customer_id, location_id});
          commit('setForecasts', response.data);
        }catch(error){
          Vue.$toast.open({
            message: `Ocorreu um erro ao fazer a busca das previsões para a localização de id: ${location_id}.`,
            type: "error",
            duration: 5000,
            dismissible: true
          });
          commit('setForecasts', undefined);
        }
  },

  async loadWaterAvailability( {commit}, payload ){
    const { location_id } = payload;
    try{
      const {data} = await loadWaterAvailability(location_id);
      const sortedArray = data.sort((a,b) => {
        if(moment(a.date).isBefore(moment(b.date))){
          return -1;
        }else if(moment(a.date).isAfter(moment(b.date))){
          return 1;
        }

        return 0;
      });

      commit('setWaterAvailability', sortedArray);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setWaterAvailability', undefined)
    }
  },
  async loadMonitoringDailyForecast( {commit}, payload ){
    const {type,source,location_id} = payload;
    try{
      const response = await loadForecasts({type,source,location_id});
      commit('setMonitoringDailyForecast', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das previsões diárias para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setMonitoringDailyForecast', undefined)
    }
  },
  async loadMeteorologicalForecast( {commit}, payload ){
    const {type,source,location_id} = payload;
    try{
      const response = await loadForecasts({type,source,location_id});
      commit('setMeteorologicalForecast', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das previsões meteorológicas para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setMeteorologicalForecast', undefined)
    }
  },
  async loadAffluentFlowForecast( {commit}, payload ){
    const {type,source,location_id,runtime} = payload;
    try{
      const response = await loadForecasts({type,source,location_id,runtime});
      commit('setAffluentFlowForecast', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das previsões de vazão dos afluentes para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setAffluentFlowForecast', undefined)
    }
  },
  async loadMonitoringDailyForecastFlows( {commit}, payload ){
    const {type,source,location_id,runtime} = payload;
    const finalDate = moment().utc().startOf("day").format();

    try{
      const response = await loadFlowForecasts(type,source,location_id,runtime,finalDate);
      const value = response.data.reduce((previous, current)=>{
        const value = previous;
        value.push({flow: current.value[0].flow, date:  current.runtime});

        return value;
      },[]);

      commit('setMonitoringDailyForecastFlows', [{value}]);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das previsões de vazão para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setMonitoringDailyForecastFlows', undefined);
    }

  },
  async loadFlowForecastsLocationId( {commit}, payload ){
    const {type, source, location_id, initial_date, final_date} = payload;

    try{
      const response = await loadFlowForecasts(type, source, location_id, initial_date, final_date)
      commit('setFlowForecasts', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das previsões de vazão para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setFlowForecasts', undefined);
    }
  },
  async loadRainfallEstimateHistory( {commit}, payload ){
    const {type, initial_date, final_date, source, location_id} = payload;

    try{
      const response = await loadForecasts({type, initial_date, final_date, source, location_id});
      commit('setRainfallEstimateHistory', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca da estimativa de chuva para a localização de id: ${location_id}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setRainfallEstimateHistory', undefined);
    }
  },
  async loadBasins( {commit}, payload ){
        const {customer_id} = payload;

        try{
          const response = await loadBasins(customer_id);
          commit('setBasins', response.data);
        }catch(error){
          Vue.$toast.open({
            message: `Ocorreu um erro ao fazer a busca das bacias para esse cliente.`,
            type: "error",
            duration: 5000,
            dismissible: true
          });
          commit('setBasins', undefined);
        }
  },

  async loadLocacronymn ( {commit}, payload){
    const {location_id, basin_id} = payload;
    try{
      const response = await loadLocations({location_id, basin_id});
      let aux = response.data
      commit('setLocacronymn', aux[0]);
    }catch(error){
      commit('setLocacronymn', undefined);
    }
  },

  async loadSaicReservoirCardSummary ({commit}){
    try{
      const response = await loadReservoirLatestDailySummary();
      let data = response.data
      commit('setSaicReservoirCardSummary', data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca dos sumários dos reservatórios SAIC.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSaicReservoirCardSummary', undefined);
    }
  },
  async loadSaicDailySummary ({commit}, { startDate, endDate }){
    try{
      const response = await loadSaicDailySummaryAPI(startDate, endDate);
      let data = response.data
      commit('setSaicDailySummary', data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca do sumário diário SAIC.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSaicDailySummary', undefined);
    }
  },
  async loadSaicMonthlySummary ({commit}, { startDate, endDate }){
    try{
      const response = await loadSaicMonthlySummaryAPI(startDate, endDate);
      let data = response.data
      commit('setSaicMonthlySummary', data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca do sumário mensal SAIC.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSaicMonthlySummary', undefined);
    }
  },

  async loadFlowDurationCurve ( {commit}, location_id){
    try {
      const response = await loadFlowDurationCurve(location_id);
      commit('setFlowDurationCurve', response.data);
    }catch(error){
      commit('setFlowDurationCurve', null);
    }
  }
};

const getters = {
  locations: (state) => state.locations,
  forecasts: (state) => state.forecasts,
  basins: (state) => state.basins,
  locacronymn: (state) => state.locacronymn,
  rainfallEstimateHistory: (state) => state.rainfallEstimateHistory,
  flowForecasts: (state) => state.flowForecasts,
  monitoringDailyForecast: (state) => state.monitoringDailyForecast,
  affluentFlowForecast: (state) => state.affluentFlowForecast,
  monitoringDailyForecastFlows: (state) => state.monitoringDailyForecastFlows,
  climatographicAverage: (state) => state.climatographicAverage,
  climatographicAverageSaic: (state) => state.climatographicAverageSaic,
  waterAvailability: (state) => state.waterAvailability,
  meteorologicalForecast: (state) => state.meteorologicalForecast,
  params: (state) => state.params,
  saicReservoirCardSummary: (state) => state.saicReservoirCardSummary,
  saicDailySummary: (state) => state.saicDailySummary,
  saicMonthlySummary: (state) => state.saicMonthlySummary,
  flowDurationCurve: (state) => state.flowDurationCurve,
  q95: (state) => state.flowDurationCurve[0]?.q95,
  q95_50: (state) => state.flowDurationCurve[0]?.q95_50,
};

export default {
    state,
    mutations,
    actions,
    getters
}
